import ko from 'knockout';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

export default function ViewModel(options) {
  this.options = options || {};
  this.gridData = ko.observableArray([]);
  this.adgroups = [];

  this.locations = ko.observableArray([]);
  this.tire2Locations = ko.observableArray([]);
  this.languages = ko.observableArray([]);
  this.numLocationsTargeted = ko.observable(0);
  this.countryLocationInfo = ko.observable([]);


  this.noSuggestionNote = ko.observable(false);

  this.allLocationsUnsupported = ko.computed(() => {
    return this.locations().length === 0 && this.numLocationsTargeted() > 0;
  });

  this.onlytire2LocationSupported = ko.computed(() => {
    return this.tire2Locations().length === this.locations().length;
  });
  this.excludedLocationsWarning = ko.computed(() => {
    if (this.locations().length !== this.numLocationsTargeted()) {
      if (this.allLocationsUnsupported()) {
        return i18n.get('KeywordPlanner_NoSuggestions_Warning');
      }

      if (this.gridData().length > 0) {
        return i18n.get('KeywordPlanner_UnsupportedLocations_Warning')
          .replace('{0}', this.locations().length)
          .replace('{1}', this.numLocationsTargeted());
      }
    }

    return false;
  });

  this.selectMultiIdeasText = ko.observable('');

  this.recentUserActionPrompt = ko.observable('');

  this.isKeywordPlannerVisible = ko.computed(() => {
    return this.gridData().length > 0;
  });
}
